<main>
  <div class="mx-4 mb-10">
    <h3 class="text-4xl font-bold mb-2">Gestão de Conta</h3>
    <p class="text-sm">Faça a gestão dos dados da sua conta e sessão</p>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-2 mx-4 gap-4">

    <div class="shadow bg-white p-8 cursor-pointer" (click)="toggleEditProfileModal()">
      <header class="text-2xl mb-4"><i class="pi pi-user text-xl mr-2 text-blue-500"></i> Editar Dados Pessoais</header>
      <p class="text-sm">Editar os dados pessoais.</p>
    </div>

    @if (!isSocialAccount) {
      <div class="shadow bg-white p-8 cursor-pointer" (click)="togglePasswordChangeModal()">
        <header class="text-2xl mb-4"><i class="pi pi-lock text-xl mr-2 text-blue-500"></i> Alteração da Palavra-passe</header>
        <p class="text-sm">Fazer a alteração da palavra-passe</p>
      </div>
    }

    @if (isSocialAccount && account?.phoneNumber) {
      <div class="shadow bg-white p-8 cursor-pointer" (click)="onRemovePhoneNumber()">
        <header class="text-2xl mb-4"><i class="pi pi-trash text-xl mr-2 text-blue-500"></i>Remover Número de Telefone</header>
        <p class="text-sm">Remover o número de telefone da sua conta</p>
      </div>
    }

    @if (!account?.phoneNumber) {
      <div class="shadow bg-white p-8 cursor-pointer" (click)="toggleAddPhoneNumberModal()">
        <header class="text-2xl mb-4"><i class="pi pi-phone text-xl mr-2 text-blue-500"></i>Adicionar Número de Telefone</header>
        <p class="text-sm">O sistema de notificações do AngolaEncontra funciona somente via SMS. Adicione ou altere um número de contacto a sua conta para poder receber notificações</p>
      </div>
    }

    <div class="shadow bg-white p-8 cursor-pointer" (click)="onTerminateAllSessions()">
      <header class="text-2xl mb-4"><i class="pi pi-user-minus text-xl mr-2 text-blue-500"></i> Remover conta conta</header>
      <p class="text-sm">Remover a minha conta e todos os dados gerados na plataforma</p>
    </div>

    <div class="shadow bg-white p-8 cursor-pointer" (click)="onLogout()">
      <header class="text-2xl mb-4"><i class="pi pi-sign-out text-xl mr-2 text-blue-500"></i> Terminar Sessão</header>
      <p class="text-sm">Terminar a sessão neste dispositivo</p>
    </div>

  </div>

  <!-- a app modal deveria estar dentro do content, assim eu teria mais controle-->
  <app-modal [header]="'Editar Dados de Pessoa'"
    [isShow]="showEditProfileModal"
    [style]="'w-auto max-w-md'"
    (cancel)="toggleEditProfileModal()">
    <app-edit-profile></app-edit-profile>
  </app-modal>

  <!-- a app modal deveria estar dentro do content, assim eu teria mais controle-->
  <app-modal [header]="'Alterar Palavra-chave'"
    [isShow]="showPasswordChangeModal"
    [style]="'w-auto max-w-md'"
    (cancel)="togglePasswordChangeModal()">
    <app-edit-password></app-edit-password>
  </app-modal>

  <app-modal [header]="'Adicionar Número de Telefone'"
    [isShow]="showAddPhoneNumberModal"
    [style]="'w-auto max-w-md'"
    (cancel)="this.showAddPhoneNumberModal = false">
    <app-add-phone-number [account]="account" (onCloseModal)="this.showAddPhoneNumberModal = false ; account = $event"></app-add-phone-number>
  </app-modal>

</main>
